import React from "react";
import cns from "classnames";
import { makeStyles } from "@material-ui/core/styles";
import { darken } from "polished";
import { ThemeType } from "@theme";
import BaseIconButton, { BaseIconButtonProps } from "./BaseIconButton";

const useStyles = makeStyles((theme: ThemeType) => ({
  root: {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.contrast,
    "&:hover, &:active": { backgroundColor: darken(0.1, theme.palette.primary.main) }
  },

  disabled: {}
}));

export const PrimaryButton: React.FC<BaseIconButtonProps> = ({
  children,
  className,
  ...rest
}) => {
  const classes = useStyles({});

  return (
    <BaseIconButton
      className={cns(classes.root, { [classes.disabled]: rest.disabled }, className)}
      variant="contained"
      color="primary"
      {...rest}
    >
      {children}
    </BaseIconButton>
  );
};

export default PrimaryButton;
